export enum ShortcutActionType {
    LIST = 'list_shortcuts',
    ADD = 'add_shortcuts',
    REMOVE = 'remove_shortcuts',
}